import { configOptions } from '../../helpers/axios';
import clientAxios from './../../config/axios';
import { Loan } from './models/Loan';
import { GetAllLoansresponse } from './models/dtos/GetAllLoansResponse';

export const createLoan = (token: string, loan: any) => {
  const url = `/loans`;
  return clientAxios.post(url, loan, configOptions(token));
};

export const loanRepayment = (token: string, loan: any) => {
  const url = `/loans?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.put(url, loan, configOptions(token));
};

export const getAllLoans = async (
  token: string,
  filter: string,
  pagination: any
): Promise<GetAllLoansresponse> => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/loans?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  const { data } = await clientAxios.get(url, configOptions(token));
  data.loans.map((loan: Loan) => {
    loan.created = new Date(loan.created);
    loan.modified = new Date(loan.modified);
    loan.date_repayment = new Date(loan.date_repayment);
    loan.complete_return_date = loan.complete_return_date
      ? new Date(loan.complete_return_date)
      : null;
    loan.detail?.map((d) => {
      d.return_date = d.return_date ? new Date(d.return_date) : null;
      return d;
    });
    return loan;
  });
  return data;
};

export const getUserLoan = (token: string, filter: any) => {
  const url = `/loand_user/?country=${process.env.REACT_APP_ENV_COUNTRY}${filter}`;
  return clientAxios.get(url, configOptions(token));
};

export const getSessionLoans = (token: string) => {
  const url = `/loans/session?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.get(url, configOptions(token));
};
